<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="contact">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item active">联系客服</div>
        </div>
        <div class="page-content-item">
          <div v-if="lxfs.wxCode || lxfs.wxNum" class="item">
            <div class="left-item">
              <div class="name">
                <img src="../../assets/pc-images/contact-wx-icon.png" class="icon" /> 微信客服
              </div>
              <div v-if="lxfs.wxNum" class="value">微信号: {{ lxfs.wxNum }}</div>
            </div>
            <el-popover v-if="lxfs.wxCode" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="lxfs.wxCode" /></div>
              <div class="img img-cover" slot="reference"><img :src="lxfs.wxCode" /></div>
            </el-popover>
          </div>
          <div v-if="lxfs.qq" class="item">
            <div class="left-item">
              <div class="name">
                <img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服
              </div>
              <div v-if="lxfs.wxNum" class="value">QQ号: {{ lxfs.qq }}</div>
            </div>
          </div>
          <div v-if="websiteInfo.ContactType1 && websiteInfo.Contact1" class="item">
            <div v-if="websiteInfo.ContactType1 == 1" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服</div>
              <div class="value">QQ号: {{ websiteInfo.Contact1.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType1 == 2" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-wx-icon.png" class="icon" /> 微信客服</div>
              <div class="value">微信号: {{ websiteInfo.Contact1.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType1 == 3" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-tg-icon.png" class="icon" /> Telegram</div>
              <div class="value">Telegram: {{ websiteInfo.Contact1.num }}</div>
            </div>
            <el-popover v-if="websiteInfo.ContactType1 == 2 && websiteInfo.Contact1.code" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="websiteInfo.Contact1.code" /></div>
              <div class="img img-cover" slot="reference"><img :src="websiteInfo.Contact1.code" /></div>
            </el-popover>
          </div>
          <div v-if="websiteInfo.ContactType2 && websiteInfo.Contact2" class="item">
            <div v-if="websiteInfo.ContactType2 == 1" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服</div>
              <div class="value">QQ号: {{ websiteInfo.Contact2.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType2 == 2" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-wx-icon.png" class="icon" /> 微信客服</div>
              <div class="value">微信号: {{ websiteInfo.Contact2.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType2 == 3" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-tg-icon.png" class="icon" /> Telegram</div>
              <div class="value">Telegram: {{ websiteInfo.Contact2.num }}</div>
            </div>
            <el-popover v-if="websiteInfo.ContactType2 == 2 && websiteInfo.Contact2.code" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="websiteInfo.Contact2.code" /></div>
              <div class="img img-cover" slot="reference"><img :src="websiteInfo.Contact2.code" /></div>
            </el-popover>
          </div>
          <div v-if="websiteInfo.ContactType3 && websiteInfo.Contact3" class="item">
            <div v-if="websiteInfo.ContactType3 == 1" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服</div>
              <div class="value">QQ号: {{ websiteInfo.Contact3.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType3 == 2" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-wx-icon.png" class="icon" /> 微信客服</div>
              <div class="value">微信号: {{ websiteInfo.Contact3.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType3 == 3" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-tg-icon.png" class="icon" /> Telegram</div>
              <div class="value">Telegram: {{ websiteInfo.Contact3.num }}</div>
            </div>
            <el-popover v-if="websiteInfo.ContactType3 == 2 && websiteInfo.Contact3.code" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="websiteInfo.Contact3.code" /></div>
              <div class="img img-cover" slot="reference"><img :src="websiteInfo.Contact3.code" /></div>
            </el-popover>
          </div>
          <div v-if="websiteInfo.ContactType4 && websiteInfo.Contact4" class="item">
            <div v-if="websiteInfo.ContactType4 == 1" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服</div>
              <div class="value">QQ号: {{ websiteInfo.Contact4.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType4 == 2" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-wx-icon.png" class="icon" /> 微信客服</div>
              <div class="value">微信号: {{ websiteInfo.Contact4.num }}</div>
            </div>
            <div v-if="websiteInfo.ContactType4 == 3" class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-tg-icon.png" class="icon" /> Telegram</div>
              <div class="value">Telegram: {{ websiteInfo.Contact4.num }}</div>
            </div>
            <el-popover v-if="websiteInfo.ContactType4 == 2 && websiteInfo.Contact4.code" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="websiteInfo.Contact4.code" /></div>
              <div class="img img-cover" slot="reference"><img :src="websiteInfo.Contact4.code" /></div>
            </el-popover>
          </div>
          <div v-if="websiteInfo.Qq" class="item">
            <div class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> QQ客服</div>
              <div class="value">QQ号: {{ websiteInfo.Qq }}</div>
            </div>
          </div>
          <div v-if="websiteInfo.Wx.status == 1 && (websiteInfo.Wx.num || websiteInfo.Wx.code)" class="item">
            <div class="left-item">
              <div class="name"><img src="../../assets/pc-images/contact-qq-icon.png" class="icon" /> 微信客服</div>
              <div v-if="websiteInfo.Wx.num" class="value">微信号: {{ websiteInfo.Wx.num }}</div>
            </div>
            <el-popover v-if="websiteInfo.Wx.code" placement="bottom" width="200" trigger="hover">
              <div class="img-cover" style="width: 200px;height: 200px;"><img :src="websiteInfo.Wx.code" /></div>
              <div class="img img-cover" slot="reference"><img :src="websiteInfo.Wx.code" /></div>
            </el-popover>
          </div>
        </div>
      </div>
    </pcUserNavComponent>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'

export default {
  name: "Contact",
  components: {
    pcTabBarComponent,
    pcUserNavComponent
  },
  data() {
    return {
      lxfs: { wxCode: '', wxNum: '', qq: '' }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    this.handleGetLxfs()
  },
  methods: {
    async handleGetLxfs() {
      var res = await this.$API.getSet.post({
        'Key': 'lxfs'
      })
      const lxfs = JSON.parse(res.info)
			this.lxfs = {
				qq: lxfs.qq,
				wxCode: lxfs.wxCode,
				wxNum: lxfs.wxNum,
			}
    }
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
  overflow: hidden;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.page-content-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 0;
  .item {
    width: 445px;
    height: 58px;
    padding: 12px 15px;
    border-radius: 5px;
    background-color: rgba(87, 131, 252, .1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .left-item {
      flex: 1;
      height: 58px;
      .name {
        display: flex;
        align-items: center;
        line-height: 28px;
        font-size: 18px;
        font-weight: 500;
        .icon {
          width: 25px;
          height: 25px;
          margin-right: 5px;
        }
      }
      .value {
        margin-top: 10px;
        color: #64748b;
      }
    }
    .img {
      width: 58px;
      height: 58px;
      border-radius: 5px;
      overflow: hidden;      
    }
  }
}
</style>